import { Pipe, PipeTransform } from '@angular/core';
import { StatusPodania } from '@interfaces/wnioski/enums/podania/podania-studenta/status-podania.enum';

@Pipe({
  name: 'statusPodania',
})
export class StatusPodaniaPipe implements PipeTransform {
  transform(value: StatusPodania): string {
    const {
      DoSkompletowania,
      CofnietoDoEdycji,
      CofnietoDoUzupelnienia,
      PozostawionoBezRozpoznania,
      Wycofano,
      Odrzucono,
    } = StatusPodania;

    switch (value) {
      case CofnietoDoEdycji:
      case CofnietoDoUzupelnienia:
      case DoSkompletowania:
        return 'bg-warning';
      case Odrzucono:
      case PozostawionoBezRozpoznania:
      case Wycofano:
        return 'bg-danger';
      default:
        return 'bg-success';
    }
  }
}
